// src/fleet-stats/utils/audience.js
//
// Classifies every client/site into an audience so the fleet story can be told
// per business relationship:
//   customer — paying customer sites (the default fleet view)
//   partner  — company partners running our robots (not working customer sites)
//   internal — our own demo/test/production sites; excluded from ALL views
//
// EDIT THE MAP BELOW to reclassify a client. Site names matching /internal/
// are always internal regardless of client.

export const CLIENT_AUDIENCE = {
    partner: "partner",   // the shared partner account (Adaptiv, Rth, Rackart, …)
    beewatec: "partner",  // its only site is "Partner"
    wheelme: "internal",  // Demo, Production
};

export const AUDIENCE_OPTIONS = [
    { key: "customer", label: "Customers", hint: "Paying customer sites" },
    { key: "partner", label: "Partners", hint: "Company partner accounts (partner, beewatec)" },
    { key: "all", label: "Both", hint: "Customers and partners together — internal sites are always excluded" },
];

export function classifyAudience(client, siteName) {
    if (/internal/i.test(siteName || "")) return "internal";
    return CLIENT_AUDIENCE[(client || "").toLowerCase()] || "customer";
}
